import ApiConstants from "../../../../../../utils/apiConstants";
import { axiosGet } from "../../../../../../packages/apiPackage/axiosRequest";

async function fetchPastExperience({ setPastExp, editionId }) {

    try {
        var response = await axiosGet({
            endpoint: `${ApiConstants.GET_PE_EXPERIENCE}/${editionId}`,
        })
        const data = response.data;
        // console.log("response = ", data);
        setPastExp(data);
        return;
    } catch (error) {
        console.log("error = ", error)
        if (!error?.response) {
            console.log("No Server Response.");
        } else if (error.response?.status === 404) {
            console.log("Page Not Found");
        } else if (error.response?.status === 400 || error.response?.status === 401) {
            console.log("User Credit Expired!!!\nPlease Login Again.");
        } else {
            console.log("Internal Server Error.");
        }
        return;
    }
}

export default fetchPastExperience;